import axios from "../axios";

export default class AuthService {
  async getAccess(data) {
    let res = await axios.post(`User/getaccess`, data);
    return res.data;
  }
}
